import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initGsapStickySidebar() {
    const sidebar = document.querySelector('.single-post-sidebar');
    const container = document.querySelector('.single-post-main');
    
    if (!sidebar || !container) return;

    ScrollTrigger.matchMedia({
        
        // Desktop only
        "(min-width: 992px)": function() {
            
            const contentRow = container.querySelector('.row'); // Main row containing col-8 and col-4
            
            const getHeaderOffset = () => {
                let offset = 20;
                if (window.APP_HEADER_HEIGHT) offset += window.APP_HEADER_HEIGHT;
                if (window.APP_TOPBAR_HEIGHT) offset += window.APP_TOPBAR_HEIGHT;
                return offset;
            };

            ScrollTrigger.create({
                trigger: sidebar,
                start: () => `top top+=${getHeaderOffset()}`,
                
                // End pinning when the parent row finishes
                endTrigger: contentRow,
                end: () => "bottom bottom", 
                
                pin: true,
                pinSpacing: true, // Changed to true to maintain layout stability
                anticipatePin: 1,
                invalidateOnRefresh: true,
                // markers: true // Descomentar para depurar si es necesario
            });
        }
    }); 
}
